export const CHANNELS_PARTNER_TYPES = {
    BUSINESS: "empresas",
    CUSTOMERS: "clientes",
};

export const BCP = "bcp";
export const BCPNEGOCIOS = "bcpnegocios";
export const BCPPYME = "bcppyme";
export const CALL_BCPPYME = "callbcppyme";
export const CALLCENTER = "callcenter";
